import { useRecoilValue } from 'recoil';
import { discountConfigState, discountConfigObjectState } from '@atoms/priceCalc';

export const TWENTY_IMAGES_COUPONS = ['GIFT40'];
export const TWENTY_IMAGES_DISCOUNT = 30;

export const SIXTEEN_COUPONS = ['GIFT35'];
export const SIXTEEN_DISCOUNT = 27;

export const TWELVE_IMAGES_COUPONS = ['GIFT12'];
export const TWELVE_IMAGES_DISCOUNT = 25;

export const EIGHT_IMAGES_COUPONS = ['GIFT20'];
export const EIGHT_IMAGES_DISCOUNT = 10;

export const SIX_IMAGES_COUPONS = ['GIFT5']
export const SIX_IMAGES_DISCOUNT = 5;

export const FIVE_IMAGES_COUPONS = ['FIVE5OFF']
export const FIVE_IMAGES_DISCOUNT = 99;

export const THREE_IMAGES_COUPONS = ['LOVEGVSX3PP', 'LOVEGVL0GPP'];
export const THREE_IMAGES_DISCOUNT = 100;

export const TEN_IMAGES_COUPONS = ['GIFT10']
export const TEN_IMAGES_DISCOUNT = 19.2;

export const TENINFLUENCER_COUPONS = ['EDEN10', 'HADAR10','EDEN15', 'NOA15', 'TAMA15'];
export const TENINFLUENCER_DISCOUNT = 15;

export const NINE_COUPONS = ['GIFT9'];
export const NINE_DISCOUNT = 20;

export const DEFAULT_COUPON = 'מבצעי חורף חמים';

export const discountConfig = {
  
  24: {
    discount: TWENTY_IMAGES_DISCOUNT,
    coupons: TWENTY_IMAGES_COUPONS,
    enableDefault: true,
    exactAmount: false,
  },
  16: {
    discount: SIXTEEN_DISCOUNT,
    coupons: SIXTEEN_COUPONS,
    enableDefault: true,
    exactAmount: true,
  },
  9: {
    discount: NINE_DISCOUNT,
    coupons: NINE_COUPONS,
    enableDefault: false,
    exactAmount: false,
    fallbackToLower: true,
  },
  
  10: {
    discount: TEN_IMAGES_DISCOUNT,
    coupons: TEN_IMAGES_COUPONS,
    enableDefault: true,
    exactAmount: false,
  },
  
  12: {
    discount: TWELVE_IMAGES_DISCOUNT,
    coupons: TWELVE_IMAGES_COUPONS,
    enableDefault: true,
    exactAmount: false,
  },
  
  8: {
    discount: EIGHT_IMAGES_DISCOUNT,
    coupons: EIGHT_IMAGES_COUPONS,
    enableDefault: true,
    exactAmount: false,
  },
  6: {
    discount: SIX_IMAGES_DISCOUNT,
    coupons: SIX_IMAGES_COUPONS,
    enableDefault: true,
    exactAmount: false,
  },
  5: {
    discount: FIVE_IMAGES_DISCOUNT,
    coupons: FIVE_IMAGES_COUPONS,
    enableDefault: false,
    exactAmount: true,
  },
  3: {
    discount: THREE_IMAGES_DISCOUNT,
    coupons: THREE_IMAGES_COUPONS,
    enableDefault: false,
    exactAmount: true
  },
};

// Re-export discountConfig as fallback for non-hook usage
export const discountConfigFallback = discountConfig;

/**
 * Hook for components that use Recoil to access dynamic discount configuration.
 * Falls back to static config if Recoil state is empty.
 */
export const useDiscountConfig = () => {
  const config = useRecoilValue(discountConfigState);
  const configObject = useRecoilValue(discountConfigObjectState);

  // Use dynamic config if available, otherwise fall back to static
  const hasValidTiers = config.tiers && config.tiers.length > 0;

  return {
    promotionName: config.promotionName || '',
    emoji: config.emoji || '',
    colors: config.colors || {
      tagBackground: '#212121',
      tagText: '#f6cd00',
      discountedPrice: '#087E63',
      bundleBadgeBackground: '#265697'
    },
    // Use dynamic config object if we have tiers, otherwise use static fallback
    discountConfig: hasValidTiers ? configObject : discountConfig,
    defaultCoupon: config.promotionName ? `מבצעי ${config.promotionName}` : ''
  };
};
